<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
		<g id="Group_44935" data-name="Group 44935" transform="translate(-926 -979.392)">
			<g id="Component_1237_6" data-name="Component 1237 – 6" transform="translate(928 981.392)">
				<g id="Group_44754" data-name="Group 44754" transform="translate(0 0)">
					<path
						id="Path_30437"
						data-name="Path 30437"
						d="M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0"
						transform="translate(0 0)"
						fill="#7e7fe7"
						stroke="#5b5be6"
						stroke-width="4"
					/>
				</g>
			</g>
			<path
				id="Path_30449"
				data-name="Path 30449"
				d="M8,26.987a1.692,1.692,0,0,1,2.391,0l7.263,7.263,7.263-7.263A1.692,1.692,0,1,1,27.3,29.378l-8.458,8.458a1.692,1.692,0,0,1-2.391,0L8,29.378a1.692,1.692,0,0,1,0-2.391Z"
				transform="translate(974.356 970.043) rotate(45)"
				fill="#fff"
				fill-rule="evenodd"
			/>
			<path
				id="Path_30450"
				data-name="Path 30450"
				d="M.495.538a1.692,1.692,0,0,1,2.391,0L10.149,7.8,17.412.538A1.692,1.692,0,1,1,19.8,2.929l-8.458,8.458a1.692,1.692,0,0,1-2.391,0L.495,2.929a1.692,1.692,0,0,1,0-2.391Z"
				transform="translate(955.041 1028.734) rotate(-135)"
				fill="#fff"
				fill-rule="evenodd"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MinimizeSvg',
};
</script>

<style scoped lang="scss"></style>
